import Avatar from "components/common/Avatar";
import CardDropdown from "components/common/CardDropdown";
import Flex from "components/common/Flex";
import AdvanceTable from "components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "components/common/advance-table/AdvanceTableWrapper";

import React, { useEffect, useState } from "react";
import { Card, Col, Dropdown, Row, Tab, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import BreadCrumb from "components/breadcrumb/BreadCrumb";
import AdvanceTableFooter from "components/common/advance-table/AdvanceTableFooter";
import { DeleteDownloads, GetDownloads, GetUsers } from "api/endpoints";
import AddUser from "./AddUser";
import { formatDateTimetoDateStr, getRelativePath } from "api/constants";
import IconButton from "components/common/IconButton";
import MEILoader from "components/ckeditor/MEILoader";
import DynamicPage from "components/dynamic-pages/DynamicPage";
import { toast } from "react-toastify";
import DeleteModal from "components/ckeditor/DeleteModal";
import AdvanceTableSearchBox from "components/common/advance-table/AdvanceTableSearchBox";
import { ExportToCSV } from "api/exports";


const Users = () => {

    const [downloads, setDownloads] = useState([]);
    const [loading, setLoading] = useState(false);


    const [key, setKey] = useState("downloads");

    const [editData, setEditData] = useState({});
    const [delData, setDelData] = useState({});
    const [deleteModal, setDeleteModal] = useState(false);


    const columns = [
        {
            accessor: "none",
            Header: "",
            disableSortBy: true,
            cellProps: {
                className: "text-end",
                // style: {maxWidth: '45px'}
            },
            Cell: (row) => {
                return (

                    <div className="d-flex gap-1">
                        {/* <IconButton icon='trash' size='sm' title='Delete' variant='danger' onClick={() => { setDelData(row.row.original.id); setDeleteModal(true) }}>
                        </IconButton> */}

                        <IconButton icon='edit' size='sm' title='Edit' onClick={() => { setEditData(row.row.original); setKey('adddownload') }}>

                        </IconButton>
                    </div>
                    // <CardDropdown>
                    //     <div className="py-2">
                    //         <Dropdown.Item href="#!">Edit</Dropdown.Item>
                    //         <Dropdown.Item href="#!">Delete</Dropdown.Item>
                    //     </div>
                    // </CardDropdown>
                );
            },
        },

        {
            accessor: "name",
            Header: "Name",
            headerProps: { className: "pe-1 text-900" },
            cellProps: {
                className: "py-2",
            },
            Cell: (rowData) => {
                const { name, avatar } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1 d-flex align-items-center gap-1">
                            {avatar ?
                                <Avatar src={getRelativePath(avatar)} />
                                :
                                <Avatar name={name} />
                            }
                            <h5 className="mb-0 fs-10">{name}</h5>
                        </div>
                    </Flex>

                );
            },
        },
        {
            accessor: "loginId",
            Header: "Email",
            headerProps: { className: "pe-1 text-900" },
            cellProps: {
                className: "py-2",
            },
            Cell: (rowData) => {
                const { loginId } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{loginId}</h5>
                        </div>
                    </Flex>

                );
            },
        },
        {
            accessor: "phoneNumber",
            Header: "Phone Number",
            headerProps: { className: "pe-1 text-900" },
            cellProps: {
                className: "py-2",
            },
            Cell: (rowData) => {
                const { phoneNumber } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            <h5 className="mb-0 fs-10">{phoneNumber}</h5>
                        </div>
                    </Flex>

                );
            },
        },


        {
            accessor: "status",
            Header: "Status",
            headerProps: { className: "text-900" },
            Cell: (rowData) => {
                const { status } = rowData.row.original;
                return (

                    <Flex alignItems="center">
                        <div className="flex-1">
                            {status ?
                                <h5 className="mb-0 fs-10 text-success">Active</h5>
                                :
                                <h5 className="mb-0 fs-10 text-danger">In-Active</h5>
                            }
                        </div>
                    </Flex>

                );
            },
        },

    ];

    const fetchDownloads = () => {
        setLoading(true)
        GetUsers().then(res => {

            setDownloads(res?.data?.data);
            setLoading(false)

        }).catch(err => {
            setLoading(false)
            console.log(err, 'GetDownloadsAPIError')
        })

    };

    useEffect(() => {
        fetchDownloads();

    }, []);


    const deleteData = () => {
        setDeleteModal(false);
        setLoading(true);
        DeleteDownloads(delData).then(res => {
            toast.success('Data deleted successfully.', {
                theme: "colored",
            });
            fetchDownloads();
        }).catch(err => {

            toast.error('Failed to delete data.', {
                theme: "colored",
            });
            setLoading(false);
        })
    }



    return (
        <>
            <div className="py-2 pt-0">
                <BreadCrumb />
            </div>

            <MEILoader showLoader={loading} />
            <DeleteModal show={deleteModal} hide={() => { setDeleteModal(false) }} deleteData={deleteData} />

            <Card className="mb-0">
                <Card.Header>
                    <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">Users</h5>
                </Card.Header>
                {/* style={{ maxHeight: '70vh', minHeight: '70vh', overflow: 'auto' }} */}
                <Card.Body className="pt-0 p-3">
                    <Tabs
                        id="controlled-tab-example"
                        activeKey={key}
                        onSelect={(k) => {
                            setKey(k);
                            if (k === 'downloads') {
                                setEditData({})
                            }
                        }}
                    >
                        <Tab
                            eventKey="downloads"
                            title="Users List"
                            className="border-bottom border-x "
                        >

                            <AdvanceTableWrapper
                                columns={columns}
                                data={downloads}
                                // dataLength={downloads.length}
                                // selection
                                sortable
                                pagination
                                perPage={100}
                            >

                                <Row className="flex-end-center mb-3 px-3" style={{ marginTop: -35 }}>
                                    <Col xs="auto" sm={5} lg={2} className="d-flex justify-content-end pe-0">
                                        <ExportToCSV
                                            columns={columns.slice(1)}
                                            data={downloads}
                                            filename={'Users'}
                                            statuses={['Published', 'Un-Published']}
                                        />
                                    </Col>
                                    <Col xs="auto" sm={6} lg={4}>
                                        <AdvanceTableSearchBox table placeholder="Search Anything..." />
                                    </Col>
                                </Row>
                                <div style={{ maxHeight: '58vh', minHeight: '58vh', overflow: 'auto' }}>
                                    <AdvanceTable
                                        table
                                        headerClassName="bg-200 text-nowrap align-middle sticky"
                                        rowClassName="align-middle white-space-nowrap"
                                        tableProps={{
                                            size: "sm",
                                            striped: true,
                                            className: "fs-10 mb-0 overflow-hidden",
                                        }}
                                    />
                                </div>
                                <AdvanceTableFooter
                                    rowCount={downloads.length || 0}
                                    table
                                    rowInfo
                                    // navButtons
                                    // rowsPerPageSelection
                                    navButtons
                                    className={'px-3 border-top'}
                                />
                            </AdvanceTableWrapper>



                        </Tab>


                        <Tab
                            eventKey="adddownload"
                            title={`${editData?.loginId ? 'Update' : 'Add'} User`}
                            className="border-bottom border-x p-3"
                        >

                            <AddUser editData={editData} handleDiscard={(reload = false) => {
                                setKey('downloads');
                                if (reload) {
                                    fetchDownloads();
                                }
                                setEditData({})
                            }} />
                        </Tab>

                    </Tabs>
                </Card.Body>
            </Card>


        </>
    );
};

export default Users;
